<carm-forms-page
  [lastLoggedOut]="lastLoggedOut$ | async"
  displayAlertsForPage="accountLinkedDashboardPage"
>
  <div class="row gc-srvinfo">
    <ng-container
      *ngFor="let feature of features | applyAcl | async; let i = index"
    >
      <div class="col-md-4" [ngClass]="{ 'clear-both': i % 3 === 0 }">
        <carm-index-page-section
          [inPath]="feature.path"
          [inDataCy]="feature.dataCy"
          inLocalizedTitle="{{
            feature.localizationKey + '.title' | translate
          }}"
          inLocalizedDescription="{{
            feature.localizationKey + '.dashboard_description' | translate
          }}"
        >
        </carm-index-page-section>
      </div>
    </ng-container>
  </div>
  <div class="row mrgn-tp-md">
    <div
      class="col-xs-12 col-sm-12 col-md-8 mrgn-tp-lg"
      *carm-acl-group="[carmResourceEnum.TRANSACTION_HISTORY, groupType.Reader]"
    >
      <carm-recent-transactions-widget></carm-recent-transactions-widget>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-4 mrgn-tp-lg">
      <carm-most-requested-widget></carm-most-requested-widget>
    </div>
    <div
      class="col-xs-12 col-sm-12 col-md-8 mrgn-tp-lg"
      *carm-acl-group="[
        carmResourceEnum.FINANCIAL_STATEMENTS,
        groupType.Reader
      ]"
    >
      <carm-financial-widget></carm-financial-widget>
    </div>
    <div
      class="col-xs-12 col-sm-12 col-md-4 mrgn-tp-lg"
      *carm-acl-group="[carmResourceEnum.DECLARATIONS, groupType.Reader]"
    >
      <carm-commercial-accounting></carm-commercial-accounting>
    </div>
    <div
      class="col-xs-12 col-sm-12 col-md-4 mrgn-tp-lg"
      *carm-acl-group="[carmResourceEnum.RULINGS, groupType.Reader]"
    >
      <carm-rulings-widget></carm-rulings-widget>
    </div>
    <div
      class="col-xs-12 col-sm-12 col-md-4 mrgn-tp-lg"
      *carm-acl-group="[carmResourceEnum.APPEALS, groupType.Reader]"
    >
      <carm-appeals></carm-appeals>
    </div>
    <div
      class="col-xs-12 col-sm-12 col-md-4 mrgn-tp-lg"
      *carm-acl-group="[carmResourceEnum.ENFORCEMENT_ACTIONS, groupType.Reader]"
    >
      <carm-penalties></carm-penalties>
    </div>
    <div
      class="col-xs-12 col-sm-12 col-md-8 mrgn-tp-lg"
      *carm-acl-group="[carmResourceEnum.EMPLOYEE, groupType.Reader]"
    >
      <carm-access-requests-widget></carm-access-requests-widget>
    </div>
    <div
      class="col-xs-12 col-sm-12 col-md-12 mrgn-tp-lg"
      *carm-acl-group="[carmResourceEnum.ALERTS, groupType.Reader]"
    >
      <carm-whats-new-widget></carm-whats-new-widget>
    </div>
  </div>
</carm-forms-page>
